<template>
  <v-dialog v-model="show" max-width="400">
    <v-card>
      <v-card-title class="text-h5">
        Delete Program
      </v-card-title>
      <v-card-text>
        Are you sure you want to delete this program?
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn class="rounded-pill" text @click="close">
          Cancel
        </v-btn>
        <v-btn class="rounded-pill elevation-0" color="accent" @click="confirm">
          Delete
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'DeleteProgramDialog',
  props: {
    value: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    show: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('input', value)
      },
    },
  },
  methods: {
    close() {
      this.show = false
      this.$emit('close')
    },
    confirm() {
      this.$emit('confirm')
    },
  },
}
</script>
